import {IBrowserHistory} from '../../routes/browserHistory';

export default function getHistoryState(): IBrowserHistory | null {
  const state = window.history.state?.usr;

  return state || null;
}